var map = {
	"./0.png": 9800,
	"./1.png": 5932,
	"./上海不列颠英国外籍人员子女学校.png": 7008,
	"./上海不列颠英国外籍人员子女学校.svg": 3868,
	"./上海交通大学附属中学.webp": 4086,
	"./上海交通大学附属中学嘉定分校.jpg": 8120,
	"./上海交通大学附属中学嘉定分校.png": 6012,
	"./上海交通大学附属中学嘉定分校2.png": 6788,
	"./上海大学附属中学.png": 764,
	"./上海市华东模范中学.png": 3860,
	"./上海市大众工业学校.png": 4628,
	"./上海市大众工业学校2.png": 168,
	"./上海市市西中学.png": 1092,
	"./上海市市西初级中学.png": 9339,
	"./上海市民办平和学校.png": 716,
	"./上海浦东新区民办惠立学校.svg": 424,
	"./上海耀中外籍人员子女学校.png": 2452,
	"./上海闵行区民办德闳学校.svg": 9484,
	"./包玉刚实验学校-单logo.png": 876,
	"./包玉刚实验学校.png": 7176,
	"./北京师范大学附属实验中学.png": 1504,
	"./南京外国语学校.png": 2864,
	"./南京外国语学校河西初级中学.jpg": 2524,
	"./南京外国语学校河西初级中学.png": 5696,
	"./南京河西外国语学校.jpg": 7320,
	"./南京河西外国语学校.png": 2856,
	"./同济大学附属七一中学.png": 7195,
	"./同济大学附属实验中学-high.png": 9572,
	"./同济大学附属实验中学.png": 4384,
	"./同济大学附属实验中学2-high.png": 8143,
	"./同济大学附属实验中学3-high.png": 9560,
	"./德威国际学校.svg": 712,
	"./江苏省苏州中学.jpg": 807,
	"./江苏省苏州中学.png": 2688,
	"./江苏省苏州中学.webp": 5640
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6560;